import React, { useEffect, useState } from "react";
import "../../assets/css/menu-mundial.css";

interface MenuMundialComponentProps {
  visibleHeight: number;
}

const MenuMundialComponent: React.FC<MenuMundialComponentProps> = ({ visibleHeight }) => {
  const [activeSection, setActiveSection] = useState<string>("");

  useEffect(() => {
    const handleScroll = () => {
      const comoParticipar = document.getElementById("como-participar");
      const cotizacion = document.getElementById("cotizacion");
      
      const scrollY = window.scrollY + 100; // Offset para detectar antes

      if (cotizacion && scrollY >= cotizacion.offsetTop) {
        setActiveSection("cotizacion");
      } else if (comoParticipar && scrollY >= comoParticipar.offsetTop) {
        setActiveSection("como-participar");
      } else {
        setActiveSection("");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
      // Opcional: actualizar el estado manual por si acaso
      setActiveSection(id);
    }
  };

  return (
    <>
      {visibleHeight <= 0 && <div style={{ height: '60px', width: '100%' }}></div>}
      <div 
        className="menu-mundial-component shadow-sm"
        style={
          visibleHeight <= 0 
            ? { position: 'fixed', top: '0px', width: '100%', zIndex: 999, left: 0 } 
            : { top: `${visibleHeight}px` }
        }
      >
      <div className="menu-mundial-container">
        <a 
          href="#como-participar"
          className={`menu-mundial-btn ${activeSection === "como-participar" ? "active" : ""}`}
          onClick={(e) => handleScrollTo(e, "como-participar")}
        >
          Cómo participar
        </a>
        <a 
          href="#cotizacion"
          className={`menu-mundial-btn ${activeSection === "cotizacion" ? "active" : ""}`}
          onClick={(e) => handleScrollTo(e, "cotizacion")}
        >
          Agenda tu Test drive
        </a>
      </div>
      </div>
    </>
  );
};

export default MenuMundialComponent;
